module.exports = __webpack_public_path__ + "static/media/logo.3df2ff46.png";